import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";

import { BannerProvider } from "../../context/BannerContext";

export const Banner = () => {
  return (
    <BannerProvider>
      <Overview />
    </BannerProvider>
  );
};

export const AddBanner = () => {
  return (
    <BannerProvider>
      <Add />
    </BannerProvider>
  );
};

export const EditBanner = () => {
  return (
    <BannerProvider>
      <Edit />
    </BannerProvider>
  );
};
